var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import React, { useMemo } from "react";
import styled from "styled-components";
import { SizeEnum } from "../../enums";
import * as ReactIcons from "@react-icons/all-files";
var TagSize = (_a = {},
    _a[SizeEnum.tiny] = {
        fontSize: "8px",
        padding: "3px 8px",
    },
    _a[SizeEnum.small] = {
        fontSize: "10px",
        padding: "4px 9px",
    },
    _a[SizeEnum.medium] = {
        fontSize: "12px",
        padding: "5px 10px",
    },
    _a[SizeEnum.large] = {
        fontSize: "14px",
        padding: "8px 15px",
    },
    _a[SizeEnum.giant] = {
        fontSize: "16px",
        padding: "10px 18px",
    },
    _a);
var StyledTag = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return "\n      display: flex;\n      align-items: center;\n      color: white;\n      background-color: ".concat(props.color, ";\n      border-radius: 20px;\n      font-weight: bold;\n      letter-spacing: .5px;\n      height: ").concat(TagSize[props.size].fontSize, ";\n      line-height: ").concat(TagSize[props.size].fontSize, ";\n      font-size: ").concat(TagSize[props.size].fontSize, ";\n      padding: ").concat(TagSize[props.size].padding, "\n");
});
var iconStyle = { marginRight: "3px" };
var Tag = function (_a) {
    var color = _a.color, label = _a.label, _b = _a.size, size = _b === void 0 ? SizeEnum.medium : _b, icon = _a.icon;
    var Icon = useMemo(function () {
        if (icon && ReactIcons[icon]) {
            return ReactIcons[icon];
        }
        return undefined;
    }, [icon]);
    return (React.createElement(StyledTag, { color: color, size: size },
        Icon !== undefined && React.createElement(Icon, { style: iconStyle }),
        label));
};
export default Tag;
var templateObject_1;
